/* Innerlight Demfin product page behaviour, ported from the v3 prototype.
   Every part checks its section exists, so sections can be removed or reordered in the theme editor. */
(function () {
  if (window.__ilDemfin) return;
  window.__ilDemfin = true;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var PAUSE = '<svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><rect x="2" y="1" width="3.5" height="12" rx="1"/><rect x="8.5" y="1" width="3.5" height="12" rx="1"/></svg>';
  var PLAY = '<svg width="14" height="14" viewBox="0 0 14 14" fill="currentColor"><path d="M3 1.5l9 5.5-9 5.5z"/></svg>';
  function tryPlay(v) { if (!v) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function init() {
    var paused = {};

    /* ---------- autoplay videos only while visible ---------- */
    var io = null;
    if ('IntersectionObserver' in window) {
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && !RM && !paused[v.id || 'x']) { if (v.preload === 'none') v.preload = 'auto'; tryPlay(v); }
          else v.pause();
        });
      }, { threshold: 0.35 });
      $$('.il video[data-auto]').forEach(function (v) { io.observe(v); });
    }

    /* ---------- video toggles ---------- */
    $$('.il [data-vt]').forEach(function (b) {
      if (RM) b.innerHTML = PLAY;
      b.addEventListener('click', function () {
        var key = b.getAttribute('data-vt');
        var v = key === 'sess' ? $('.il .sess-stage video.on') : document.getElementById(key);
        if (!v) return;
        var nowPaused = !paused[key];
        if (RM && paused[key] === undefined) nowPaused = false;
        paused[key] = nowPaused;
        if (nowPaused) { v.pause(); b.innerHTML = PLAY; b.setAttribute('aria-label', 'Play video'); }
        else { tryPlay(v); b.innerHTML = PAUSE; b.setAttribute('aria-label', 'Pause video'); }
      });
    });

    /* ---------- session: scroll-driven clip switching ---------- */
    var stage = $('.il .sess-stage');
    var steps = $$('.il .step'), sv = stage ? $$('video, .sess-media', stage) : [], bars = $$('.il .sess-bar i'), timeEl = $('.il .sess-time');
    var curStep = 0, sessVisible = false;
    function setStep(i) {
      if (i === curStep || !steps.length) return; curStep = i;
      steps.forEach(function (s, j) { s.classList.toggle('on', j === i); });
      sv.forEach(function (v, j) {
        if (j === i) { v.classList.add('on'); if (v.tagName !== 'VIDEO') return; if (v.preload !== 'auto') v.preload = 'auto'; try { v.currentTime = 0; } catch (e) {} if (sessVisible && !RM && !paused.sess) tryPlay(v); }
        else { v.classList.remove('on'); if (v.tagName === 'VIDEO') v.pause(); }
      });
      if (i + 1 < sv.length && sv[i + 1].tagName === 'VIDEO') sv[i + 1].preload = 'auto';
      if (timeEl) timeEl.textContent = steps[i].getAttribute('data-t') || '';
    }
    if (stage && io) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { sessVisible = e.isIntersecting; var v = sv[curStep]; if (!v || v.tagName !== 'VIDEO') return; if (sessVisible && !RM && !paused.sess) tryPlay(v); else v.pause(); });
      }, { threshold: 0.2 }).observe(stage);
    }

    /* ---------- statement: words light up as you scroll ---------- */
    var stmt = $('.il [data-stmt]'), words = [];
    if (stmt) {
      var html = '';
      [].slice.call(stmt.childNodes).forEach(function (n) {
        if (n.nodeType === 3) html += n.textContent.split(/(\s+)/).map(function (w) { return /\S/.test(w) ? '<span class="w">' + esc(w) + '</span>' : w; }).join('');
        else if (n.nodeType === 1) html += '<em class="w">' + esc(n.textContent) + '</em>';
      });
      stmt.innerHTML = html; words = $$('.w', stmt);
    }

    /* ---------- scroll-linked effects ---------- */
    var hero = $('.il .hero'), heroMedia = $('.il .hero-media'), heroCopy = $('.il .hero-copy');
    var exS = $('.il .expand'), exF = $('.il .expand-frame'), tl = $('.il .tl'), res = document.getElementById('reserve'), tv = $('.il [data-temp]');
    var ticking = false;
    /* The page may scroll inside a wrapper (Shopify's preview bar does this), not the window. */
    function scroller() {
      var el = document.querySelector('.il'); el = el && el.parentElement;
      while (el && el !== document.body && el !== document.documentElement) {
        var o = getComputedStyle(el).overflowY;
        if ((o === 'auto' || o === 'scroll') && el.scrollHeight > el.clientHeight + 1) return el;
        el = el.parentElement;
      }
      return null;
    }
    function pageY() { var sc = scroller(); return sc ? sc.scrollTop : (window.scrollY || document.documentElement.scrollTop || 0); }
    function frame() {
      ticking = false;
      var vh = window.innerHeight;
      if (hero && heroMedia && heroCopy && !RM) {
        var hr = hero.getBoundingClientRect(); var p = clamp(-hr.top / (hr.height * 0.9), 0, 1);
        heroMedia.style.transform = 'scale(' + (1 - p * 0.08) + ')';
        heroMedia.style.borderRadius = (p * 36) + 'px';
        heroCopy.style.transform = 'translateY(' + (-p * 60) + 'px)';
        heroCopy.style.opacity = String(1 - p * 0.9);
      }
      if (stmt && words.length) {
        var sr = stmt.getBoundingClientRect(); var mid = sr.top + sr.height / 2; var sp = clamp((vh * 0.9 - mid) / (vh * 0.5), 0, 1);
        var lit = RM ? words.length : Math.round(sp * words.length);
        words.forEach(function (w, i) { w.classList.toggle('lit', i < lit); });
      }
      if (steps.length) {
        var best = 0, bd = 1e9;
        steps.forEach(function (s, i) { var r = s.getBoundingClientRect(); var d = Math.abs(r.top + r.height / 2 - vh * 0.5); if (d < bd) { bd = d; best = i; } });
        setStep(best);
        steps.forEach(function (s, i) { if (!bars[i]) return; var r = s.getBoundingClientRect(); var f = i < best ? 1 : (i > best ? 0 : clamp((vh * 0.5 - r.top) / r.height, 0.05, 1)); bars[i].style.setProperty('--f', f); });
      }
      if (exS && exF) {
        var er = exS.getBoundingClientRect(); var ep = RM ? 1 : clamp(-er.top / (er.height - vh), 0, 1);
        var e = Math.min(1, ep * 1.6);
        exF.style.setProperty('--w', 62 + 38 * e); exF.style.setProperty('--h', 62 + 38 * e); exF.style.setProperty('--r', 28 * (1 - e));
        exF.style.setProperty('--o', String(0.35 + 0.65 * clamp((ep - 0.3) / 0.4, 0, 1)));
      }
      if (res) {
        var sy = pageY();
        var top = res.getBoundingClientRect().top + sy;
        var hp = clamp(sy / Math.max(1, top - vh * 0.6), 0, 1);
        document.documentElement.style.setProperty('--heat', hp.toFixed(3));
        if (tv) tv.textContent = Math.round(20 + 70 * hp) + '°C';
      }
      if (tl) { var tr = tl.getBoundingClientRect(); tl.style.setProperty('--tp', RM ? 1 : clamp((vh * 0.8 - tr.top) / (vh * 0.5), 0, 1)); }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    document.addEventListener('scroll', onScroll, { passive: true, capture: true }); window.addEventListener('resize', onScroll); frame();

    /* ---------- rails ---------- */
    $$('.il .paddles').forEach(function (p) {
      var rail = document.getElementById(p.getAttribute('data-for')); var btns = $$('.paddle', p);
      if (!rail || btns.length < 2) return;
      function upd() { var max = rail.scrollWidth - rail.clientWidth - 2; btns[0].disabled = rail.scrollLeft <= 2; btns[1].disabled = rail.scrollLeft >= max; }
      btns.forEach(function (b) { b.addEventListener('click', function () { var card = rail.firstElementChild; var step = card ? card.getBoundingClientRect().width + 20 : 300; rail.scrollBy({ left: +b.getAttribute('data-dir') * step * (window.innerWidth > 900 ? 2 : 1), behavior: RM ? 'auto' : 'smooth' }); }); });
      rail.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true }); window.addEventListener('resize', upd); upd();
    });

    /* ---------- overlays ---------- */
    var lastFocus = null, openOv = null;
    function openO(el) { lastFocus = document.activeElement; el.hidden = false; openOv = el; document.documentElement.style.overflow = 'hidden'; var x = $('.ov-x', el); if (x) x.focus(); }
    function closeO() {
      if (!openOv) return; var el = openOv; el.hidden = true; openOv = null; document.documentElement.style.overflow = '';
      $$('video', el).forEach(function (v) { v.pause(); });
      var sm = $('[data-sheet-media]', el); if (sm) sm.innerHTML = '';
      if (lastFocus) lastFocus.focus();
    }
    $$('.il [data-close]').forEach(function (b) { b.addEventListener('click', closeO); });
    $$('.il .ov').forEach(function (o) { o.addEventListener('click', function (e) { if (e.target === o) closeO(); }); });
    document.addEventListener('keydown', function (e) {
      if (!openOv) return;
      if (e.key === 'Escape') closeO();
      else if (openOv.hasAttribute('data-lightbox') && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) lbShow(lbAt + (e.key === 'ArrowRight' ? 1 : -1));
      else if (e.key === 'Tab') {
        var f = $$('button,video[controls],a[href]', openOv).filter(function (x) { return x.offsetParent !== null; }); if (!f.length) return;
        var a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });

    /* film: any [data-film] button plays its source in the film overlay */
    var filmOv = $('.il [data-film-overlay]'), filmVid = filmOv ? $('video', filmOv) : null;
    $$('.il [data-film]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!filmOv || !filmVid) return;
        var src = b.getAttribute('data-film') || filmOv.getAttribute('data-default-src');
        var po = b.getAttribute('data-poster') || filmOv.getAttribute('data-default-poster') || '';
        if (!src) return;
        if (filmVid.getAttribute('src') !== src) { filmVid.setAttribute('src', src); if (po) filmVid.setAttribute('poster', po); }
        openO(filmOv); filmVid.preload = 'auto'; try { filmVid.currentTime = 0; } catch (e) {} tryPlay(filmVid);
      });
    });

    /* ---------- details: hover to preview, tap for the sheet ---------- */
    var detList = $('.il .det-list'), detMedia = $('.il .det-media');
    if (detList && detMedia) {
      var rows = $$('.det-row', detList), items = $$(':scope > video, :scope > img', detMedia), cap = $('.det-cap', detMedia), detAt = 0, detVis = false;
      var detSet = function (i) {
        detAt = i;
        rows.forEach(function (r, j) { r.classList.toggle('on', j === i); });
        items.forEach(function (m, j) {
          m.classList.toggle('on', j === i);
          if (m.tagName === 'VIDEO') { if (j === i && detVis && !RM) { m.preload = 'auto'; tryPlay(m); } else m.pause(); }
        });
        if (cap && rows[i]) cap.textContent = rows[i].getAttribute('data-kicker') + ' · ' + rows[i].getAttribute('data-title');
      };
      rows.forEach(function (r, i) { r.addEventListener('mouseenter', function () { detSet(i); }); r.addEventListener('focus', function () { detSet(i); }); });
      if (io) new IntersectionObserver(function (es) { es.forEach(function (e) { detVis = e.isIntersecting; detSet(detAt); }); }, { threshold: 0.3 }).observe(detMedia);
      var sheetOv = $('.il [data-sheet-overlay]');
      rows.forEach(function (r) {
        r.addEventListener('click', function () {
          if (!sheetOv) return;
          var tpl = document.getElementById(r.getAttribute('data-sheet')); if (!tpl) return;
          var m = $('[data-sheet-media]', sheetOv), c = $('[data-sheet-copy]', sheetOv);
          var frag = tpl.content.cloneNode(true);
          m.className = 'sheet-media' + (r.hasAttribute('data-white') ? ' white' : '');
          m.innerHTML = ''; c.innerHTML = '';
          var media = frag.querySelector('[data-part="media"]'), copy = frag.querySelector('[data-part="copy"]');
          if (media) m.appendChild(media); if (copy) c.appendChild(copy);
          var v = $('video', m); if (v) { if (RM) v.removeAttribute('autoplay'); else tryPlay(v); }
          openO(sheetOv);
        });
      });
    }

    /* ---------- gallery + lightbox ---------- */
    var gal = $('.il [data-gallery]'), lbAt = 0, lbShow = function () {};
    if (gal) {
      var gT = $('.g-track', gal), thumbs = $$('.g-th', gal), slides = $$('.g-slide', gal), gCur = $('[data-g-cur]', gal), gCap = $('.g-cap', gal), gi = 0;
      var gPrev = $('.g-prev', gal), gNext = $('.g-next', gal);
      var caps = slides.map(function (s) { return s.getAttribute('data-caption') || ''; });
      var srcs = slides.map(function (s) { return s.getAttribute('data-full') || ''; });
      var gSet = function (i) {
        gi = i; if (gCur) gCur.textContent = i + 1; if (gCap) gCap.textContent = caps[i];
        thumbs.forEach(function (t, j) { t.classList.toggle('on', j === i); });
        if (gPrev) gPrev.disabled = i === 0; if (gNext) gNext.disabled = i === slides.length - 1;
        var t = thumbs[i], box = t && t.parentElement; if (box) box.scrollTo({ left: t.offsetLeft - box.clientWidth / 2 + t.clientWidth / 2, behavior: RM ? 'auto' : 'smooth' });
      };
      var gGo = function (i) { i = clamp(i, 0, slides.length - 1); gT.scrollTo({ left: i * gT.clientWidth, behavior: RM ? 'auto' : 'smooth' }); gSet(i); };
      var gtm; gT.addEventListener('scroll', function () { clearTimeout(gtm); gtm = setTimeout(function () { var i = Math.round(gT.scrollLeft / gT.clientWidth); if (i !== gi) gSet(i); }, 70); }, { passive: true });
      if (gPrev) gPrev.addEventListener('click', function () { gGo(gi - 1); });
      if (gNext) gNext.addEventListener('click', function () { gGo(gi + 1); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { gGo(i); }); });
      gT.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); gGo(gi + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); gGo(gi - 1); } });
      if (slides.length) gSet(0);
      var lbOv = $('.il [data-lightbox]');
      if (lbOv) {
        var lbImg = $('img', lbOv), lbC = $('[data-lb-caption]', lbOv);
        lbShow = function (i) { lbAt = (i + slides.length) % slides.length; lbImg.src = srcs[lbAt]; lbImg.alt = caps[lbAt]; if (lbC) lbC.textContent = caps[lbAt] + '  ·  ' + (lbAt + 1) + ' of ' + slides.length; };
        $$('[data-lb]', gT).forEach(function (b, i) { b.addEventListener('click', function () { lbShow(i); openO(lbOv); }); });
        var p = $('[data-lb-prev]', lbOv), n = $('[data-lb-next]', lbOv);
        if (p) p.addEventListener('click', function () { lbShow(lbAt - 1); });
        if (n) n.addEventListener('click', function () { lbShow(lbAt + 1); });
        var sx = null;
        lbOv.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        lbOv.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) lbShow(lbAt + (dx < 0 ? 1 : -1)); sx = null; });
      }
    }

    /* ---------- local nav highlight ---------- */
    var navLinks = $$('.il .lnav-links a');
    var secs = navLinks.map(function (a) { var h = a.getAttribute('href'); return h && h.charAt(0) === '#' ? document.getElementById(h.slice(1)) : null; });
    if (io) {
      var nio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { var i = secs.indexOf(e.target); navLinks.forEach(function (a, j) { a.classList.toggle('on', j === i); }); } });
      }, { rootMargin: '-45% 0px -50% 0px' });
      secs.forEach(function (s) { if (s) nio.observe(s); });
    }

    /* ---------- animated dimensions ---------- */
    var box = $('.il .dimbox');
    if (box) {
      var nums = $$('.dlab b', box), unit = 'cm', timers = [];
      var fmt = function (cm, u, p) { var v = cm * p; if (u === 'cm') return String(Math.round(v)); var inch = Math.round(v / 2.54), ft = Math.floor(inch / 12), i = inch - ft * 12; return ft + '′' + i + '″'; };
      var setUnits = function () { $$('.dlab i', box).forEach(function (i) { i.textContent = unit === 'cm' ? 'cm' : ''; }); nums.forEach(function (n) { n.textContent = fmt(+n.dataset.cm, unit, 1); }); };
      var count = function () {
        timers.forEach(cancelAnimationFrame); timers = [];
        nums.forEach(function (n, k) {
          var cm = +n.dataset.cm, delay = (k * 350) + 250, dur = 900, t0 = null;
          var step = function (t) { if (t0 === null) t0 = t; var e = Math.min(1, Math.max(0, (t - t0 - delay) / dur)); var p = 1 - Math.pow(1 - e, 3); n.textContent = fmt(cm, unit, p); if (e < 1) timers.push(requestAnimationFrame(step)); };
          timers.push(requestAnimationFrame(step));
        });
      };
      var play = function () {
        if (RM) { box.classList.remove('pre'); setUnits(); return; }
        box.classList.remove('run'); box.classList.add('pre'); void box.offsetWidth;
        requestAnimationFrame(function () { box.classList.remove('pre'); box.classList.add('run'); count(); });
      };
      var played = false;
      if (!RM) box.classList.add('pre');
      if (io) new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting && !played) { played = true; play(); } }); }, { threshold: 0.45 }).observe(box);
      else box.classList.remove('pre');
      var rp = $('[data-dim-replay]', box); if (rp) rp.addEventListener('click', play);
      $$('.seg button', box).forEach(function (b) {
        b.addEventListener('click', function () { unit = b.dataset.u; $$('.seg button', box).forEach(function (x) { x.classList.toggle('on', x === b); }); timers.forEach(cancelAnimationFrame); setUnits(); });
      });
    }

    /* hero video: start after page load so the still image is the fast first paint */
    var hv = document.getElementById('heroVid');
    if (hv) {
      hv.addEventListener('playing', function () { hv.classList.add('is-playing'); });
      var saveData = navigator.connection && navigator.connection.saveData;
      var startHero = function () { if (RM || saveData) return; if (io) io.observe(hv); else { hv.preload = 'auto'; tryPlay(hv); } };
      if (document.readyState === 'complete') setTimeout(startHero, 300); else window.addEventListener('load', function () { setTimeout(startHero, 300); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
